import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_PROJECT_APPLICATION_SETTINGS } from 'gql/projectApplicationSetting';
import { SelectWithSearch } from 'components/input';

const ProTableSearchProjectApplicationSetting = (props) => {
  const { data, loading } = useQuery(GET_PROJECT_APPLICATION_SETTINGS, {
    showPriorities: [0, 2],
  });
  const options = data
    ? data.projectApplicationSettings.map(({ id, title }) => ({
        label: title,
        value: id,
      }))
    : [];
  return (
    <SelectWithSearch
      options={options}
      loading={loading}
      value={props.value}
      onChange={props.onChange}
    />
  );
};

export default ProTableSearchProjectApplicationSetting;
